import { emptyCommands } from "../state/state.initial";
import { State } from "../state/state";
import { Mask, Commands, CommandServer, MaskServer } from "../../../shared";
import Utils from "../../../utils";

export const fromServer = (data: State.InputServer): State.Input => {
  let cmds: Commands<Mask> = Object.assign({}, emptyCommands);

  data.cmds.forEach(cmd => (cmds[cmd.url] = cmd.data.mask.split("") as Mask));
  return {
    id: data.id,
    status: Utils.numToBool(data.status),
    cmds: cmds
  };
};

export const toServer = (
  data: Partial<State.Input>
): Partial<State.InputServer> => {
  let ret: Partial<State.InputServer> = {};
  let cmds: CommandServer<MaskServer>[] = [];
  if (data.id) ret.id = data.id;
  if (data.cmds != null) {
    for (let key in data.cmds) {
      let mask = data.cmds[key].join("");
      cmds.push({
        url: key,
        data: { mask: mask }
      });
    }
    ret.cmds = cmds;
  }
  return ret;
};
